import { createAuthClient } from "better-auth/react";

const baseURL = import.meta.env.VITE_API_URL || "https://streamshare-functions-preview-preview.iserialize.workers.dev";

export const authClient = createAuthClient({
  baseURL: baseURL + "/api/auth",
});

export const { useSession, signIn, signUp, signOut } = authClient;
